/* unplugin-vue-components disabled */import { render } from "./add-sample.vue?vue&type=template&id=7f6fec56&scoped=true"
import script from "./add-sample.vue?vue&type=script&lang=js"
export * from "./add-sample.vue?vue&type=script&lang=js"

import "./add-sample.vue?vue&type=style&index=0&id=7f6fec56&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f6fec56"],['__file',"src/pages/playground/add-sample.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7f6fec56"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7f6fec56', __exports__)) {
    api.reload('7f6fec56', __exports__)
  }
  
  module.hot.accept("./add-sample.vue?vue&type=template&id=7f6fec56&scoped=true", () => {
    api.rerender('7f6fec56', render)
  })

}


export default __exports__